//!USER
export const SIGN_IN = "SIGN_IN";
export const SIGN_UP = "SIGN_IN";
export const SIGN_OUT = "SIGN_OUT";
export const GET_USER = "GET_USER";
export const SHOW_USER = "SHOW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const ALL_USERS = "ALL_USERS";

//!ART
export const FETCH_ARTS = "FETCH_ARTS";
export const LOADING_ARTS = "LOADING_ARTS";
export const RESET_ALL_LOADED = "RESET_ALL_LOADED";
export const FETCH_ARTS_INF_SCROLL = "FETCH_ARTS_INF_SCROLL";
export const CREATE_ART = "CREATE_ART";
export const SEND_ART_TO_STATE = "SEND_ART_TO_STATE";
export const SEND_ARTS_TO_STATE = "SEND_ARTS_TO_STATE";
export const REMOVE_STATE = "REMOVE_STATE";
export const UPDATE_ARTS = "UPDATE_ARTS";

//!COMMENT
export const CREATE_ART_COMMENT = "CREATE_ART_COMMENT";
export const CREATE_COMMENT_COMMENT = "CREATE_COMMENT_COMMENT";
export const CREATE_ART_SHOW_COMMENT = "CREATE_ART_SHOW_COMMENT";

//!LIKE
export const CREATE_COMMENT_LIKE = "CREATE_COMMENT_LIKE";
export const CREATE_ART_LIKE = "CREATE_ART_LIKE";
export const DESTROY_ART_LIKE = "DESTROY_ART_LIKE";
export const DESTROY_COMMENT_LIKE = "DESTROY_COMMENT_LIKE";

//!SALE
export const FETCH_ALL_SALES = "FETCH_ALL_SALES";
export const FETCH_ALL_SALES_COMPRESSED = "FETCH_ALL_SALES_COMPRESSED";
export const FETCH_SALE = "FETCH_SALE";
export const REMOVE_SALE_STATE = "REMOVE_SALE_STATE";

//!METAMASK
export const CONNECT = "CONNECT";

//!UI
export const ALERT = "ALERT";
export const SET_OPEN = "SET_OPEN";
export const SET_DROPPED = "SET_DROPPED";
export const LOWER_ALERT = "LOWER_ALERT";
export const SHOW_MENU = "SHOW_MENU";
export const MODAL = "MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
